var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"LayoutFill",attrs:{"mb-5":"","no-gutters":_vm.noGutters}},[_c('v-col',{class:_vm.noPadding ? 'pb-0' : undefined,attrs:{"cols":"12"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }